import request from '@/utils/request';

export function getPredata(params) {
  return request({
    url: '/api/external/qianshanHuaShang/predata',
    method: 'get',
    params,
  });
}
export function postDigitalEnvelope(data) {
  return request({
    url: '/api/external/qianshanHuaShang/digitalEnvelope',
    method: 'post',
    data,
  });
}
export function getQrcode(params) {
  return request({
    url: '/api/external/epoint/bzt/qrcode',
    method: 'get',
    params,
  });
}
export function getQueryResult(params) {
  return request({
    url: '/api/external/epoint/bzt/queryResult',
    method: 'get',
    params,
  });
}

export default { getPredata, postDigitalEnvelope, getQrcode, getQueryResult };
